import React from 'react'

import { Checkin, Iptaliade, PnrSorgu } from '@enuygun/icons'

export const informationCardData = [
  {
    heading: 'Online check-in',
    subheading: 'Uçuşundan önce online check-in yap, havalimanında vakit kazan.',
    icon: <Checkin width={40} height={40} />,
    src: 'https://www.enuygun.com/ucak-bileti/check-in/',
  },
  {
    heading: 'PNR sorgulama',
    subheading: 'Uçak, otobüs bileti ve otel rezervasyonu durumunu sorgula.',
    icon: <PnrSorgu width={40} height={40} />,
    src: 'https://www.enuygun.com/ucak-bileti/pnr-sorgulama/',
  },
  {
    heading: 'İptal / İade işlemleri',
    subheading: 'Uçak ve otobüs bileti iptal iade işlemlerini kolayca yap.',
    icon: <Iptaliade width={40} height={40} />,
    src: 'https://www.enuygun.com/bilet-iptal-iade/',
  },
]

/*     
bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/online-checkin-48035.png',
bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/pnr-sorgu-48036.png',
bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/iptal-iade-48037.png', 
*/
